import React from 'react';
import { ANALYSES_META_INFO } from '../../../settings';

import { Row, Col } from '../../ui/Grid';
import DeepSEAForm from './DeepSEAForm';
import DeepSEAJobSelector from './DeepSEAJobSelector';

// Define the prefill type
interface PrefillType {
  textarea?: string;
  title?: string;
}

// Define the component props
interface DeepSEAJobManagerProps {
  analysis: string;
  prefill?: PrefillType | null;
  modelName?: string | null;
}

const DeepSEAJobManager: React.FC<DeepSEAJobManagerProps> = ({
  analysis,
  prefill = null,
  modelName = null,
}) => {
  return (
    <Row style={{ display: 'flex', flexWrap: 'wrap' }}>
      <Col md={6} xs={12} sm={6} style={{ paddingLeft: 0 }}>
        <DeepSEAForm
          key={analysis}
          analysis={analysis}
          prefill={prefill}
          defaultModelName={ANALYSES_META_INFO[analysis].defaultModelName}
          modelName={modelName}
        />
      </Col>
      <Col md={6} xs={12} sm={6} style={{ padding: '34px 0 0 0' }}>
        <DeepSEAJobSelector analysis={analysis} />
      </Col>
    </Row>
  );
};

export default DeepSEAJobManager;
